(function () {
  if (document.documentElement.dataset.zenMainProductScriptLoaded === 'true') return;

  document.documentElement.dataset.zenMainProductScriptLoaded = 'true';

  var sectionSelector = '[data-zen-product-page]';

  function getSections(container) {
    var root = container || document;
    var sections = [];

    if (root.matches && root.matches(sectionSelector)) sections.push(root);

    return sections.concat(Array.prototype.slice.call(root.querySelectorAll(sectionSelector)));
  }

  function destroySection(section) {
    if (typeof section.zenMainProductCleanup === 'function') {
      section.zenMainProductCleanup();
    }
  }

  function initializeSection(section) {
    if (section.dataset.zenMainProductInitialized === 'true') return;

    var cleanupCallbacks = [];
    var timeoutIds = [];
    var labels = {
      addToCart: section.dataset.zenProductAddToCartLabel,
      soldOut: section.dataset.zenProductSoldOutLabel,
      inStock: section.dataset.zenProductInStockLabel,
      outOfStock: section.dataset.zenProductOutOfStockLabel,
      adding: section.dataset.zenProductAddingLabel,
      added: section.dataset.zenProductAddedLabel,
      error: section.dataset.zenProductErrorLabel,
    };

    function addListener(element, eventName, callback) {
      element.addEventListener(eventName, callback);
      cleanupCallbacks.push(function () {
        element.removeEventListener(eventName, callback);
      });
    }

    var mainImage = section.querySelector('[data-zen-main-image]');
    var thumbs = section.querySelectorAll('[data-zen-thumb]');

    thumbs.forEach(function (thumb) {
      function showImage() {
        var fullImage = thumb.getAttribute('data-full-image');
        if (!mainImage || !fullImage) return;

        mainImage.src = fullImage;

        thumbs.forEach(function (item) {
          item.classList.remove('is-active');
        });

        thumb.classList.add('is-active');
      }

      addListener(thumb, 'click', showImage);
    });

    var qtyInput = section.querySelector('[data-zen-qty-input]');
    var qtyMinus = section.querySelector('[data-zen-qty-minus]');
    var qtyPlus = section.querySelector('[data-zen-qty-plus]');

    if (qtyInput && qtyMinus && qtyPlus) {
      function decreaseQuantity() {
        var current = parseInt(qtyInput.value || '1', 10);
        qtyInput.value = Math.max(1, current - 1);
      }

      function increaseQuantity() {
        var current = parseInt(qtyInput.value || '1', 10);
        qtyInput.value = current + 1;
      }

      addListener(qtyMinus, 'click', decreaseQuantity);
      addListener(qtyPlus, 'click', increaseQuantity);
    }

    var variantJson = section.querySelector('[data-zen-variants-json]');
    var variantInput = section.querySelector('[data-zen-variant-id]');
    var availabilityOverride = section.dataset.zenAvailabilityOverride === 'true';
    var optionSelects = section.querySelectorAll('[data-zen-option-select]');
    var addButton = section.querySelector('[data-zen-add-button]');
    var priceContainer = section.querySelector('[data-zen-product-price]');
    var stockIndicator = section.querySelector('[data-zen-product-stock]');
    var stockText = section.querySelector('[data-zen-product-stock-text]');
    var skuRow = section.querySelector('[data-zen-product-sku-row]');
    var skuValue = section.querySelector('[data-zen-product-sku]');

    function updateAvailability(available) {
      if (!stockIndicator) return;

      var isAvailable = available || availabilityOverride;
      stockIndicator.classList.toggle('is-in-stock', isAvailable);
      stockIndicator.classList.toggle('is-out-of-stock', !isAvailable);

      if (stockText) {
        stockText.textContent = isAvailable ? labels.inStock : labels.outOfStock;
      }
    }

    if (variantJson && variantInput && optionSelects.length) {
      var variants = [];

      try {
        variants = JSON.parse(variantJson.textContent);
      } catch (error) {
        variants = [];
      }

      function updateVariant() {
        var selectedOptions = Array.prototype.map.call(optionSelects, function (select) {
          return select.value;
        });

        var matchedVariant = variants.find(function (variant) {
          return variant.options.every(function (option, index) {
            return option === selectedOptions[index];
          });
        });

        if (!matchedVariant) return;

        variantInput.value = matchedVariant.id;

        if (priceContainer && matchedVariant.priceFormatted) {
          priceContainer.textContent = matchedVariant.priceFormatted;

          if (matchedVariant.compareAtPriceFormatted) {
            var compareAtPrice = document.createElement('span');
            compareAtPrice.textContent = matchedVariant.compareAtPriceFormatted;
            priceContainer.appendChild(compareAtPrice);
          }
        }

        if (mainImage && matchedVariant.featuredImage) {
          mainImage.src = matchedVariant.featuredImage;
          mainImage.alt = matchedVariant.featuredImageAlt || mainImage.alt;

          thumbs.forEach(function (thumb) {
            if (thumb.getAttribute('data-full-image') === matchedVariant.featuredImage) {
              thumb.classList.add('is-active');
            } else {
              thumb.classList.remove('is-active');
            }
          });
        }

        if (skuRow && skuValue) {
          skuValue.textContent = matchedVariant.sku || '';
          skuRow.hidden = !matchedVariant.sku;
        }

        var variantUrl = new URL(window.location.href);
        variantUrl.searchParams.set('variant', matchedVariant.id);
        window.history.replaceState({}, '', variantUrl.toString());

        if (addButton) {
          var addButtonText = addButton.querySelector('.zen-product-add__text');
          var addButtonArrow = addButton.querySelector('[aria-hidden="true"]');

          if (matchedVariant.available || availabilityOverride) {
            addButton.disabled = false;
            if (addButtonText) addButtonText.textContent = labels.addToCart;
            if (addButtonArrow) addButtonArrow.hidden = false;
          } else {
            addButton.disabled = true;
            if (addButtonText) addButtonText.textContent = labels.soldOut;
            if (addButtonArrow) addButtonArrow.hidden = true;
          }
        }

        updateAvailability(matchedVariant.available);
      }

      optionSelects.forEach(function (select) {
        addListener(select, 'change', updateVariant);
      });

      updateVariant();
    }

    section.dataset.zenMainProductInitialized = 'true';
    section.zenMainProductCleanup = function () {
      cleanupCallbacks.forEach(function (cleanup) {
        cleanup();
      });
      timeoutIds.forEach(function (timeoutId) {
        window.clearTimeout(timeoutId);
      });
      delete section.dataset.zenMainProductInitialized;
      delete section.zenMainProductCleanup;
    };
  }

  function initializeSections(container) {
    getSections(container).forEach(initializeSection);
  }

  function destroySections(container) {
    getSections(container).forEach(destroySection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initializeSections(document);
    });
  } else {
    initializeSections(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initializeSections(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    destroySections(event.target);
  });
})();
